module.exports = __webpack_public_path__ + "media/images/fr_ca/connect_dots-bda139bd4faba8b4bd42e5f8252ae003.png";